import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const WordFileIcon = createSvgIcon(
  <g>
    <rect x="8" y="8" width="48" height="48" rx="10" fill="#2B579A" />
    <text
      x="32"
      y="43"
      textAnchor="middle"
      fill="#FFFFFF"
      fontFamily="Segoe UI, Inter, ui-sans-serif, system-ui, sans-serif"
      fontSize="26"
      fontWeight="800"
    >
      W
    </text>
  </g>,
  'WordFileIcon',
);
